/**
 * Findings Mock Data
 * Contains dummy data for license findings and recommendations
 * This data will be replaced with real API responses when backend is ready
 */

import type { Finding } from '../components/Dashboard/Findings/type';

const FINDINGS_MOCK_DATA: Finding[] = [
  {
    id: '1',
    title:
      'Your organization spend on Productivity software is 14% higher than Industry avg.',
    description: '',
    category: 'Cost Reduction',
    savings: 113500,
    savingsLabel: 'License Savings',
    impact: 'High',
    effort: 'Low',
    timeline: '14 Days',
    confidence: 92,
    vendor: 'Salesforce',
  },
  {
    id: '2',
    title:
      'You can save an estimated $144,000 over the next 90 days by adjusting role classifications',
    description: '',
    category: 'Cost Reduction',
    savings: 65500,
    savingsLabel: 'License Savings',
    impact: 'High',
    effort: 'Low',
    timeline: '14 Days',
    confidence: 81,
    vendor: 'SAP',
  },
  {
    id: '3',
    title:
      'You have an upcoming audit for Microsoft SQL. Run a report now to identify potential issues',
    description: '',
    category: 'Cost Reduction',
    savings: 21000,
    savingsLabel: 'License Savings',
    impact: 'High',
    effort: 'Low',
    timeline: '14 Days',
    confidence: 81,
    vendor: 'Office 365',
  },
  {
    id: '4',
    title:
      'Your total annual license subscriptions will increase by 11.6% in 2026. Review the forecast.',
    description: '',
    category: 'Cost Reduction',
    savings: 11000,
    savingsLabel: 'License Savings',
    impact: 'High',
    effort: 'Low',
    timeline: '14 Days',
    confidence: 81,
    vendor: 'AWS',
  },
];

export default FINDINGS_MOCK_DATA;
